import { NavMenu } from '@shopify/app-bridge-react'
import { Tabs as PolarisTabs } from '@shopify/polaris'
import { Link } from 'react-router-dom'

import { anyWindow } from './helpers'
import { MaintenanceBanner } from './MaintenanceBanner'
import { PricingPlanBanner } from './PricingPlanBanner'
import { ReauthBanner } from './ReauthBanner'
import { SellingPlanPageWarningBanner } from './SellingPlanPageWarningBanner'
import * as urls from './urls'

export enum TabIndex {
  Dashboard,
  Plans,
  Subscriptions,
  Workflows,
  CustomerPortalSettings,
  Settings,
  Partners,
}

const tabs = [
  { id: 'home', content: 'Dashboard', url: urls.dashboardUrl() },
  { id: 'plans', content: 'Plans', url: urls.plansUrl },
  { id: 'subscriptions', content: 'Subscriptions', url: urls.subscriptionsUrl() },
  { id: 'workflows', content: 'Workflows', url: urls.workflowsUrl },
  { id: 'customer-portal', content: 'Customer Portal', url: urls.customerPortalSettingsUrl() },
  { id: 'settings', content: 'Settings', url: urls.settingsUrl() },
  { id: 'partners', content: 'Our Partners', url: urls.partnersUrl },
]

export const Tabs = ({ selected }: { selected: TabIndex }) => {
  return (
    <>
      {anyWindow.adminMode && <PolarisTabs tabs={tabs} selected={selected} />}
      <ReauthBanner />
      <MaintenanceBanner />
      {tabs[selected].id !== 'plans' && <PricingPlanBanner />}
      {tabs[selected].id === 'plans' && <SellingPlanPageWarningBanner />}
    </>
  )
}

export const NativeNavigationMenu = () => {
  return (
    <NavMenu>
      {tabs.map(({ id, content, url }, index) => (
        <Link key={`nav-${id}`} to={url} rel={id === 'home' ? id : ''}>
          {content}
        </Link>
      ))}
    </NavMenu>
  )
}
